import React, { useState } from 'react'
import { FaPlus,FaMinus } from "react-icons/fa";
const Product_Count = () => {
     const [count, setCount] = useState(1); 

  const increment = () => setCount(count + 1);

  const decrement = () => setCount(count > 1 ? count - 1 : 1); 

  return (
    <div className="flex items-center gap-2 border-[#000000] border-2 p-2 rounded-[30px]">
      <button
        onClick={decrement}
        className="bg-transparent p-2 text-[16px]"
        disabled={count === 1}
      >
       <FaMinus/>
      </button>

      <span className="text-xl font-medium w-8 text-center">{count}</span>

      <button
        onClick={increment}
        className="bg-transparent p-2 text-[16px]"
      >
        <FaPlus/>
      </button>
    </div>
  )
}

export default Product_Count
